import { put, select } from 'redux-saga/effects';
import API from '@utils/api';
import { filterOutList } from '@utils/filters';
import CouponsActions from './CouponsRedux';
import AppActions from './AppRedux';
import logger from '@utils/logger';

const transformCoupon = (item, offices) => {
  let office;
  let val = item.officeID;

  if (Array.isArray(val)) {
    office = val
      .map(value => {
        return offices.find(officeItem => officeItem.officeID === value);
      })
      .filter(value => !!value)
      .map(value => value.name);
  } else {
    office = offices.find(officeItem => officeItem.officeID === val);
    if (office && office.name) {
      office = office.name;
    }
  }

  return {
    ...item,
    office
  };
};

const getPropertyKeys = couponData => {
  const { propertyID } = couponData;
  if (!propertyID) {
    return;
  }

  if (Array.isArray(propertyID)) {
    const propertyKeys = propertyID.filter(item => !!item);
    if (!propertyKeys.length) {
      return;
    }

    return propertyKeys;
  }

  return [propertyID];
};

export function* fetchCoupons() {
  yield put(CouponsActions.setCouponsLoading(true));

  try {
    const { result } = yield API.fetchCoupons();
    const state = yield select();
    let { offices } = state.app;
    if (!offices || !offices.length) {
      const { result: officesResult } = yield API.fetchOffices();
      yield put(AppActions.setAllOffices(officesResult));
      offices = officesResult;
    }

    const coupons = result.map(item => transformCoupon(item, offices));

    yield put(CouponsActions.setCoupons(coupons));

    yield put(
      CouponsActions.updateCouponFilterList(filterOutList(coupons, 'coupons'))
    );
    yield put(CouponsActions.setCouponsLoading(false));
  } catch (err) {
    logger.error('err: ', err);
  }
}

export function* fetchCoupon(actions) {
  const { couponId } = actions;
  yield put(CouponsActions.setCouponsLoading(true));

  const state = yield select();

  const { couponsList } = state.coupons;
  let coupon;

  let existingCoupon = couponsList.find(
    item => `${item.couponID}` === `${couponId}`
  );

  if (!existingCoupon) {
    try {
      const { result } = yield API.fetchCoupon(couponId);
      existingCoupon = result || {};
    } catch (err) {
      existingCoupon = {};
    }
  }

  const isFixedAmount = !existingCoupon.percentage;
  const amount = isFixedAmount
    ? existingCoupon.amount
    : existingCoupon.percentage;

  coupon = { ...existingCoupon, isFixedAmount, amount };

  const propertyKeys = getPropertyKeys(coupon);

  if (propertyKeys && propertyKeys.length) {
    try {
      const getPropertyPromise = propertyKeys.map(propertyKey =>
        API.fetchProperty(propertyKey)
      );
      const properties = yield Promise.all(getPropertyPromise);

      coupon.property = properties.map(data => {
        const { result } = data;
        const { name, propertyID: key } = result || {};
        return { name, key };
      });
    } catch (err) {
      logger.error('err: fetchCoupon', err);
    }
  }

  yield put(CouponsActions.setCouponData(coupon));

  yield put(CouponsActions.setCouponsLoading(false));
}
